// src/components/common/LoadingOverlay.tsx
import React from "react";
import "./LoadingOverlay.css";

interface LoadingOverlayProps {
  visible: boolean;
}

// Full-screen transparent dim overlay shown while the app is refreshing or
// navigating between pages. It only ever appears ON TOP of already-rendered
// content (never over a blank page), so it looks like a slight dim/shadow.
// The component stays mounted at all times so the opacity can transition
// smoothly (fade in / fade out). Pointer events are blocked only while visible.
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible }) => {
  return (
    <div
      className={`loading-overlay${visible ? " visible" : ""}`}
      aria-hidden="true"
    />
  );
};